export default {
    xboot: 'XBoot is a very good one-stop front-end and back-end separation rapid development platform',
    usernameLogin: 'Username Sign in',
    mobileLogin: 'Phone',
    autoLogin: 'Auto Login',
    forgetPass: 'Forget Password',
    otherLogin: 'Sign in with',
    regist: 'Register',
    register: "Register",
    registering: "Registering...",
    registerNow: "No account yet��Register now",
    loginNow: "Sign in with an account",
    login: 'Sign in',
    logining: 'Signing in...',
    ocr: "Image recognition",
    home: 'home',
    switchLangTitle: 'Switch Lang',
    international: 'Switch Lang',
    userCenter: 'Account Center',
    changePass: 'Modify Pass',
    logOut: 'Sign out',
    tagOption: 'Labels',
    closeAll: 'Close All',
    closeOthers: 'Close Others',
    help: 'Help',
    privacy: 'Privacy',
    terms: 'Terms',
    rights: 'All Rights Reserved',
    sso: "XBoot Authentication Platform",
    authorize: "Authorize",
    authorizeAndSignin: "Authorize and Sign in",
    authorizing: "Authorizing...",
    wants: "wants to access your account",
    wants2: "",
    authAquire: "Public data only",
    aquireInfo: "Limited access to your public data",
    afterAuth: "Authorizing will redirect to",
    relateTitle: "Bind XBoot's Account",
    relate: "Bind",
    relating: "Binding...",
    textbtn: "Text",
    docbtn: "Document",
    autoDetection: "Auto detect",
    standard: "Unicode 2010",
    newstandard: "Temp stand 2022",
    menkcode: "Menk Code",
    translateSwitch: "Word translation",
    translateOpen: "on",
    translateClose: "off",
    asr: "Click the button for voice input, click again for recognition.",
    copy: "Click button to copy the result.",
    ononproduct: "Onon Product",
    share: "Share",
    onondoc: "Onon Document",
    ononoffice: "Onon Office",
    ononmap: "Onon Map",
    en: "En",
    zh: "Zh",
    kiril: "Cyril",
    ononime: "Onon input method",
    auxiliaryTranslation: "Onon CAT",
    mt: "Intelligent translation",
    ononfont: "Onon Fonts",
    onondic: "Onon Dictionary",
    mnconvert: "Mongolian conversion",
    selectcode: "Select the source text encoding type (automatic detected by default).",
    targetcode: "Select the target text encoding type",
    platformnameforcodeconvert: "Code conversion",
    platformnamefortranslate: "Translate",
    platformnameforconvert: "Mongolian conversion",
    historybtn: "Historical records",
    historyview: "Login to view history",
    historynull: "no history",
    historyremoveall: "All history cleared",
    historyremoveforcurrent: "Removed from current history",
    backtop: "Back to top",
    resultXm: "Correct glyph",
    resultErr: "error",
    clear: "clear",
    transtip: "Delimitation translation is enabled by default. If you don't need this function, please turn it off by yourself",
    accuracy: "There are two kinds of accuracy, namely, the accuracy of character display and the accuracy of internal code.",
    shape: "glyph",
    sound: "code",
    dlhcode: "Delehi Code",
    convertok: "Convert",
    debounceinfo: "Send the request after 2500 milliseconds after entering the text, and click the convert / translate button to send the request after 700 milliseconds",
    debouncetitle: "Delayed conversion prompt",
    logout: "Log out",
    favorites: "favorites",
    defaultObjSelectedName: "please choose",
    placholder: "Please enter or paste the source text to be converted ...",
    ononTrans: "Translate",
    ononConvert: "Convert",
    guideicon: "guide",
    clearhistory: "clear history",
    nohistory: "no history",
    uploadtip: "Click or drag the file here to upload",
    uploadsuffix: "Please select .doc, .docx etc. document",
    historygetdata: "Save only the last 30 history records",
    step1: "Prepare for conversion",
    step2: "Check coding type",
    step3: "Converting",
    step4: "Completed",
    step_trans_1: "Prepare for translate",
    step_trans_2: "Translating",
    step_trans_3: "Translation complete",
    company: "Onon Technology co., ltd all rights reserved",



    tzh: "Chinese",
    ten: "English",
    mo: "Mongolian",
    mobz: "Mongolian（Unicode 2010）",
    momkl: "Mongolian（Menk Code）",
    momw: "Mongolian（Temp stand 2022）",
    selectlang: "Select source language",
    objlang: "Select target language",
    transok: "Translate",
    transplacholder: "Please enter the original text to be translated...",
    transplacholderNew: "Please enter the original text to be translated, new users can use it 5 times for free...",
    resultplacholder: "translation",

    convertplacholder: "Please enter the text to be converted ...",
    convertresultplacholder: "Convert text",
    convertmo: "Traditional Mongolian",
    convertkiril: "Cyrillic",

    allnewupdatetag: "New upgrade",

    codeconvert_select_outcode: "Please select output code",
    codeconvert_sourcecode_outcode_eq_msg: "Source character encoding is identical to target character encoding. Please choose a different character encoding type.",
    codeconvert_tips: "Converted ",


    copyd: "Copied",
    copydfail: "Copy failed, please copy manually",
    copydnull: "There is nothing to copy",
    serviceerr: "Api error",
    source_target_eq_msg: "The original language must be different from the target language, please select again!",


    site_convert_title: "Mongolian conversion - intelligent conversion between traditional Mongolian and Cyrillic",
    site_code_convert_title: "Code conversion - accurate and efficient multi-format conversion",
    site_translate_title: "Onon Translation-Accurate and efficient Mongolian translation tool",

    check_codeconvert_slected_tips: "It is detected that the source encoding type is the same as the last recorded target encoding type, and the target encoding type has been automatically reset for you",
    wxtips: "Tips",

    placewait: "please wait",

    maxlimit: "Exceeds the specified character limit",
    proofread: "Text proofreading",

    myTraffic: "My resources",
    statisticalInformation: "Statistical information",
    orderManagement: "Order management",
    noRealNameUser: "No real name user",
    ononbook: "Onon Book",
    ononLanguageResources: "Onon Language Resources",

    productCenter: "Product center",
    internetService: 'Internet service',
    officeSoftware: 'Office software',
    languageIndustry: 'Language industry',
    productSupport: 'Product Support',
    aboutUs: 'About us',
    followUs: 'Follow us',
    ononCollege: 'Onon college',
    userGuide: 'User guide',
    audioBook: 'Audio book',
    qualificationHonor: 'Qualification honor',
    joinUs: 'Join us',
    mediaReports: 'Media reports',
    legalNotices: 'Legal notices',

    pleaseLogInToTranslate: 'Please log in to translate',
    buy: 'Buy',
    invoiceManagement: "Invoice management",

    myMembers: "My members",
    remainingFlow: "Remaining resources",
    maturity: "maturity",
    character: "character",
    frequency: "frequency",
    word: "word",

    automaticDetection: "Automatic detection",
    unableToTecognizeLanguage: "Current language detection is not supported, please enter traditional Mongolian, Chinese, or English",

    limitedExemption: 'Free',

    weChatGroup: "WeChat group",
    technicalServices: "Technical Services",
    feedback: "Feedback",

    PleasLogInToConvert: "Please log in to convert",
    loggedOut: "Logged out",

    realTimeTranslation: "Real-time translation",
    paste: "Paste",
    clipboardIsEmpty: "Clipboard is empty",
    kindTips: "Kind tips",
    moreApplications: "More Applications",
    free5: "Your free usage times have been used up, please log in to continue using! <br> New users can get 3,000 characters by registering and logging in.",
    openVip: "Become an SVIP",
    ISee: "I see",
    tts: "Speech Synthesis",
};